import './Table.module.css'
function InteractiveTable(props) {

            
    let tableHead = (
        <>
            <tr >
                {props.colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);
        
    let tableRows = props.tableRows.map((row, rowIndex) => (
        <tr key={`row_${rowIndex}`}>
            {Object.keys(row).map((key) => {
                if (key === 'selected') {
                    return (
                        <td key={`${key}_${rowIndex}`}>
                            <input 
                                id={`${key}_${rowIndex}`} 
                                onChange={props.inputHandler} 
                                type='checkbox' 
                                checked={row[key]} 
                            />
                        </td>
                    );
                } else {
                    return (
                        <td key={`${key}_${rowIndex}`}>
                            <textarea 
                                id={`${key}_${rowIndex}`} 
                                onChange={props.inputHandler} 
                                type='text' 
                                placeholder='Enter ...' 
                                autoComplete='false' 
                                value={row[key]} 
                                style={{fontFamily: 'Roboto'}}
                            />
                        </td>
                    );
                }
            })}
        </tr>
    ));
    


    return(<>
        <table >
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={props.colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default InteractiveTable;
